var map = {
	"./AcademyCatalog.vue": [
		35600,
		5600
	],
	"./AppLayout.vue": [
		87220
	],
	"./Blank.vue": [
		82446,
		2446
	],
	"./BlankAcademy.vue": [
		12425,
		2425
	],
	"./EmbedAcademy.vue": [
		59180,
		9180
	],
	"./Flow.vue": [
		23552,
		3552
	],
	"./FullHeight.vue": [
		40837,
		837
	],
	"./Login.vue": [
		37374,
		7374
	],
	"./Main.vue": [
		43736,
		3736
	],
	"./MainBg.vue": [
		58761,
		8761
	],
	"./NoHeader.vue": [
		22923,
		2923
	],
	"./v2/Main.vue": [
		88453,
		8453
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20062;
module.exports = webpackAsyncContext;